import React from "react";
import appStore from "../assets/PopUp/app-store.png";
import playStore from "../assets/PopUp/play-store.png";
import bannerPopup from "../assets/PopUp/banner-pop-up.png";

const AppBanner = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="relative bg-white rounded-xl shadow-lg w-11/12 max-w-xl p-6 text-center">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-2xl text-gray-500 hover:text-gray-800 focus:outline-none"
        >
          &times;
        </button>

        {/* Banner Image */}
        <img
          src={bannerPopup}
          alt="App Promo Banner"
          className="w-full h-auto mb-6 rounded-md"
        />

        {/* Store Buttons */}
        <div className="flex justify-center space-x-6 mt-4">
          <a
            href="https://apps.apple.com/us/app/goodpeople-call/id6740238582"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={appStore}
              alt="Download on the App Store"
              className="h-20 hover:scale-110 transition-transform duration-200"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.emotalk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={playStore}
              alt="Get it on Google Play"
              className="h-20 hover:scale-110 transition-transform duration-200"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppBanner;
